<template>
  <section class="observations">
    <h3 class="subtitle my-0">
      {{ title }}
    </h3>

    <ul class="list-unstyled pl-0">
      <li>
        La respuesta a este reclamo o queja será enviada al correo electrónico consignado en el presente formulario.
      </li>
      <li>
        Con el envío del presente formulario, EL USUARIO valida la información consignada y declara haber sido debidamente informado por {{ business.name }}  sobre el procedimiento, plazo de atención y medio de respuesta correspondiente.      </li>
      <li>
        En caso el reclamo resulte procedente o improcedente, la decisión será notificada al correo electrónico proporcionado.
      </li>
      <li>
        Al registrar su reclamo o queja, se generará un código único que será enviado a su correo electrónico para su seguimiento.
      </li>
      <li>
        En caso no se consigne como mínimo el nombre, número de documento, dirección o correo electrónico, y la descripción del reclamo o queja, este será considerado no presentado, conforme al artículo 5 del Reglamento del Libro de Reclamaciones.
      </li>
      <li>
        La formulación del reclamo no impide acudir a otras vías de solución de controversias ni es requisito previo para presentar una denuncia ante INDECOPI.
      </li>
      <li>
        Este establecimiento cuenta con un Libro de Reclamaciones a disposición del consumidor, conforme a lo exigido por la Ley.
      </li>
    </ul>

    <h4>MUCHAS GRACIAS POR SU COMUNICACIÓN,</h4>

    <h5 class="mb-0">
      Atentamente,
      <br/>
      {{ business.name }}
    </h5>
  </section>
</template>

<script>
export default {
  props: {
    title: String,
    business: Object
  }
};
</script>

<style lang="stylus">
@import "../Styles/observations.styl"
</style>
